"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const operation_1 = require("./operation/operation");
const query_1 = require("./query/query");
class SingleDataSourceRepository {
    constructor(getDataSource, putDataSource, deleteDataSource) {
        this.getDataSource = getDataSource;
        this.putDataSource = putDataSource;
        this.deleteDataSource = deleteDataSource;
    }
    get(queryOrId, operation) {
        return this.getDataSource.get(queryOrId);
    }
    getAll(queryOrId, operation) {
        return this.getDataSource.getAll(queryOrId);
    }
    put(value, queryOrId = new query_1.VoidQuery(), operation = new operation_1.DefaultOperation()) {
        return this.putDataSource.put(value, queryOrId);
    }
    putAll(values, queryOrIds = new query_1.VoidQuery(), operation = new operation_1.DefaultOperation()) {
        return this.putDataSource.putAll(values, queryOrIds);
    }
    delete(queryOrId = new query_1.VoidQuery(), operation = new operation_1.DefaultOperation()) {
        return this.deleteDataSource.delete(queryOrId);
    }
    deleteAll(queryOrIds = new query_1.VoidQuery(), operation = new operation_1.DefaultOperation()) {
        return this.deleteDataSource.deleteAll(queryOrIds);
    }
}
exports.SingleDataSourceRepository = SingleDataSourceRepository;
class SingleGetDataSourceRepository {
    constructor(getDataSource) {
        this.getDataSource = getDataSource;
    }
    get(queryOrId, operation) {
        return this.getDataSource.get(queryOrId);
    }
    getAll(queryOrId, operation) {
        return this.getDataSource.getAll(queryOrId);
    }
}
exports.SingleGetDataSourceRepository = SingleGetDataSourceRepository;
class SinglePutDataSourceRepository {
    constructor(putDataSource) {
        this.putDataSource = putDataSource;
    }
    put(value, queryOrId = new query_1.VoidQuery(), operation = new operation_1.DefaultOperation()) {
        return this.putDataSource.put(value, queryOrId);
    }
    putAll(values, queryOrIds = new query_1.VoidQuery(), operation = new operation_1.DefaultOperation()) {
        return this.putDataSource.putAll(values, queryOrIds);
    }
}
exports.SinglePutDataSourceRepository = SinglePutDataSourceRepository;
class SingleDeleteDataSourceRepository {
    constructor(deleteDataSource) {
        this.deleteDataSource = deleteDataSource;
    }
    delete(queryOrId = new query_1.VoidQuery(), operation = new operation_1.DefaultOperation()) {
        return this.deleteDataSource.delete(queryOrId);
    }
    deleteAll(queryOrIds = new query_1.VoidQuery(), operation = new operation_1.DefaultOperation()) {
        return this.deleteDataSource.deleteAll(queryOrIds);
    }
}
exports.SingleDeleteDataSourceRepository = SingleDeleteDataSourceRepository;
